import { LocalStorageService } from './../../core/services/local-storage.service';
import { RateService } from './../../core/services/RateService/RateService.service';
import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  serverError,
  successEvaluation,
  successEvaluationupdate,
} from './../../core/models/messages';
import { Subject, takeUntil } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { CResponseReview } from './../../core/models/Rate';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-rate-wegestu',
  templateUrl: './rate-wegestu.component.html',
  styleUrls: ['./rate-wegestu.component.css'],
})
export class RateWegestuComponent {
  evaluationForm!: FormGroup;
  listQuestions: any;
  questions: any[] = [];
  isspinner: boolean = false;
  pagination: boolean = false;

  /* unsubscription */
  private unsubscribeAll: Subject<void> = new Subject();
  /* pagination */
  totalItems: number = 10;
  itemsPerPage: number = 5;
  currentPage: number = 1;
  startIndex: number = 0;
  endIndex: number = 10;
  dataComment: any;
  loadSpinner: boolean = false;
  commentLengthError: boolean = false;
  responseData: any[] = [];
  userResponses: number[] = [];
  comment: string = '';
  evaluationData: any;
  currentUser: any;
  responsecandidat: any;
  /* modal */
  @ViewChild('modal') modal: any;
  /* modal */
  modalRef?: BsModalRef;
  showStar: boolean = false;
  editReviewForm!: FormGroup;
  starRatings: number[] = [1, 2, 3, 4, 5];
  selectedRating: number = 0;
  showBtnEdit: boolean = false;
  id_comment: any;
  addComment: boolean = false;
  show_submit: boolean = true;
  isCommentEmpty: boolean = true;
  dataEditEvaluation: any;
  showcomment: boolean = false;
  commentToEdit: any;
  company_id: any;

  constructor(
    private formBuilder: FormBuilder,
    private evaluationService: RateService,
    private toastrService: ToastrService,
    private spinner: NgxSpinnerService,
    private localStorageService: LocalStorageService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
  ) {}

  ngOnInit() {
 

    const connectedUser = JSON.parse(this.localStorageService.getData('UserInfo') || '{}') 
    this.company_id = connectedUser?.company?.uuid

    this.getEvaluationWegestuByIdCandidate();
    this.editReviewForm = this.reviewForm(new CResponseReview());
    this.editReviewForm.get('stars')?.valueChanges.subscribe((rating) => {
      this.selectedRating = rating;
    });
  }

  getEvaluationWegestuByIdCandidate() {
    this.spinner.show();
    this.isspinner = true;
    this.evaluationService
      .getEvaluationWegestuByIdCandidate(this.company_id)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res: any) => {
          if (res.status == 200) {
            this.spinner.hide();
            this.isspinner = false;
            console.log("res",res)
            this.responsecandidat = res.data;
            console.log('+++++responsecandidat', this.responsecandidat);
            this.dataComment = res.comment;
            console.log(
              '+++++responsecandidashowcommentshowcommentshowcommentshowcommentt',
              this.dataComment?.comment
            );

            if (
              this.dataComment?.comment !== null &&
              this.dataComment?.comment !== undefined
            ) {
              this.showBtnEdit = true;
              this.id_comment = this.dataComment?.id;
              this.comment = this.dataComment?.comment;
              this.commentToEdit = this.comment;
              this.showcomment = true;
            } else {
              this.spinner.hide();
              this.isspinner = false;
              this.showcomment = false;
              console.log(
                '%crate-wegest-u.component.ts line:150 not exist',
                'color: #007acc;'
              );
              this.addComment = true;
            }

            // Filter the data array to include only items with a null comment
            const responsesWithoutComment = this.responsecandidat.filter(
              (response: any) =>
                response.response_evaluate_wegestu[0]?.comment === null
            );

            // Map the filtered array to the userResponses array
            this.userResponses = new Array(responsesWithoutComment.length).fill(
              0
            );

            // Map the responses to the userResponses array based on the question IDs
            responsesWithoutComment.forEach((response: any, index: number) => {
              const questionId =
                response.response_evaluate_wegestu[0].evaluate_wegestu_id;
              const questionIndex = this.responsecandidat.findIndex(
                (question: any) => question.id === questionId
              );

              if (questionIndex !== -1) {
                this.userResponses[questionIndex] =
                  parseInt(response.response_evaluate_wegestu[0].stars, 10) ||
                  0;
              }
            });

            console.log('userResponses+++++', this.userResponses);
          }
        },
        error: (err: any) => {
          if (err.error) {
          }
        },
      });
  }

  /* get pagination items */
  getItems(event?: any) {
    if (event) {
      this.startIndex = event.startIndex;
      this.endIndex = event.endIndex;
      (this.itemsPerPage = event.itemsPerPage),
        (this.currentPage = event.currentPage);
        if( (this.startIndex !=0 || this.endIndex !=5) || this.pagination == true){
          this.pagination == true
         this.getEvaluationWegestuByIdCandidate();
        }
    }
  }

  /* create review form */
  reviewForm(data: CResponseReview) {
    return this.formBuilder.group({
      id: [data.id, [Validators.required]],
      question: [data.question, [Validators.required]],
      stars: [data.stars, [Validators.required]],
    });
  }

  ratings: any = [];
  // update new senario
  setRating(questionId: any, index: number, stars: number) {
    console.log('addComment', this.addComment);
    console.log('questionId', questionId);

    this.userResponses[index] = stars;

    this.ratings.push({
      evaluate_wegestu_id: questionId.id,
      stars: stars,
    });
    let data2 = {
      responses: this.ratings,
    };
    this.dataEditEvaluation = data2;
    console.log('dataEditEvaluation', this.dataEditEvaluation);
  }

  /* edite response */
  editResponse() {
    const id = this.id_comment;
    const comment = this.commentToEdit;
    let data = { ...this.dataEditEvaluation };
    if (comment !== '') {
      data = { ...this.dataEditEvaluation, comment };
    }
    else{
      data = { ...this.dataEditEvaluation, comment:"" };
    }
    console.log("data",data)
    this.spinner.show();
    this.loadSpinner = true;
    this.evaluationService
      .updateEvaluation(data)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          if (res.status == 200) {
            this.toastrService.success(successEvaluationupdate);
            this.getEvaluationWegestuByIdCandidate();
             this.router.navigate(['/list-reviews']);
            this.spinner.hide();
            this.loadSpinner = false;
          }
        },
        error: (err: any) => {
          this.spinner.hide();
          this.loadSpinner = false;
          if (err.error) {
            this.toastrService.error(serverError);
          }
        },
      });
  }

  /* edite Response */
  submitFormEdit() {
    this.editResponse();
  }

  // addEvaluationwegestU() {
  //   const data = {
  //     comment: this.comment,
  //   };
   
  //   this.addEvaluationwegestU_1(this.comment);
  // }

  addEvaluationwegestU_1() {
    console.log("bnj")
   let comment=this.comment
    let data = { ...this.dataEditEvaluation };
    console.log("comment",comment)
    if (comment && comment !== '') {
      console.log("if")
      data = { ...this.dataEditEvaluation, comment };
    }
    else {
      console.log("else")
      data = { ...this.dataEditEvaluation, comment:""};
    }
    // let newData = { ...this.evaluationData, ...data }
    this.evaluationService
      .addEvaluationWegestu(data)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          if (res.status == 200) {
            this.toastrService.success(successEvaluation);
            this.getEvaluationWegestuByIdCandidate();
            this.addComment = false;
            this.showcomment = true;
            this.showStar = true;
            this.router.navigate(['/list-reviews']);
          }
        },
        error: (err: any) => {
          if (err.error) {
            this.toastrService.error(serverError);
          }
        },
      });
  }

  checkCommentLength() {
    if (this.comment.length > 400 || this.commentToEdit.length > 400) {
      this.commentLengthError = true;
    } else {
      this.commentLengthError = false;
    }
  }

  /* unsubscribe from api */
  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }
}
